// Copyright 2024 Sorama B.V.
import { InvalidParameterError } from "errors/InvalidParameterError";
import { Unit, UnitType } from "./Unit";

export class Loudness extends UnitType {
    public static override typeName = "Loudness";

    public static Sones: Unit = new Unit("Sones", 1, Loudness);
}

export class Sharpness extends UnitType {
    public static override typeName = "Sharpness";

    public static Acum: Unit = new Unit("Acum", 1, Sharpness);
}

export class FluctuationStrength extends UnitType {
    public static override typeName = "Fluctuation Strength";

    public static Vacils: Unit = new Unit("Vacils", 1, FluctuationStrength);
}

export class Tonality extends UnitType {
    public static override typeName = "Tonality";

    public static tuHMS: Unit = new Unit("tuₕₘₛ", 1, Tonality);
}

export class Roughness extends UnitType {
    public static override typeName = "Roughness";

    public static Aspers: Unit = new Unit("Aspers", 1, Roughness);
}

export class PsychoAcousticUnits {
    public static fromString(typeName: string): Unit {
        switch (typeName) {
            case Loudness.typeName:
                return Loudness.Sones;
            case Sharpness.typeName:
                return Sharpness.Acum;
            case FluctuationStrength.typeName:
                return FluctuationStrength.Vacils;
            case Tonality.typeName:
                return Tonality.tuHMS;
            case Roughness.typeName:
                return Roughness.Aspers;
            default:
                throw new InvalidParameterError(typeName + " cannot be found");
        }
    }
}
